import React from 'react';
import { IconProps } from '.';

const SvgNumThreeFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M11.974 16.575c2.129 0 3.659-1.16 3.646-2.774.013-1.178-.749-2.018-2.136-2.187v-.078c1.055-.19 1.79-.938 1.784-1.993.007-1.49-1.302-2.656-3.268-2.656-1.934 0-3.392 1.127-3.424 2.748h1.875c.032-.723.716-1.192 1.549-1.185.833-.007 1.387.488 1.38 1.21.007.743-.644 1.25-1.575 1.25h-.873v1.446h.873c1.107.007 1.79.547 1.784 1.315.006.762-.665 1.283-1.602 1.29-.911-.007-1.595-.47-1.628-1.173H8.38c.04 1.647 1.524 2.787 3.594 2.787Z'
      />
    </svg>
  );
};

export default SvgNumThreeFill;
